var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-text-field',_vm._g(_vm._b({directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],attrs:{"type":"numeric","pattern":"[0-9]*","inputmode":"numeric","outlined":"","rounded":""}},'core-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }